var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-container"},[_c('div',{staticClass:"map-content",attrs:{"id":_vm.mapId}}),_c('drag-box',{ref:"dragBox"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }